const VERIFIED_STATUSES = new Set([
  "verified",
  "active",
  "approved",
  "true",
  "1",
]);

function isVerifiedAccount(account = {}) {
  if (typeof account.is_verified === "boolean") return account.is_verified;
  if (typeof account.isVerified === "boolean") return account.isVerified;

  const status = String(
    account.verification_status || account.status || ""
  ).toLowerCase();

  return VERIFIED_STATUSES.has(status);
}

const UPI_PAYOUT_METHODS = new Set(["upi", "upi_id", "vpa"]);

/**
 * The player API keeps bank and UPI payout destinations in one collection, so
 * `GET bank-accounts` returns UPI rows too. Detect them so the bank lists can
 * drop them.
 */
export function isUpiPayoutAccount(account = {}) {
  const method = String(
    account.payout_method || account.payoutMethod || ""
  ).toLowerCase();

  if (method) return UPI_PAYOUT_METHODS.has(method);

  // Older payloads omit payout_method: a row carrying a UPI handle and no bank
  // coordinates is a UPI destination. Anything else stays in the bank list.
  const hasUpiId = Boolean(account.upi_id || account.upiId);
  const hasBankFields = Boolean(
    account.account_number ||
      account.accountNumber ||
      account.account_number_masked ||
      account.accountNumberMasked ||
      account.ifsc_code ||
      account.ifscCode ||
      account.bank_name ||
      account.bankName
  );

  return hasUpiId && !hasBankFields;
}

function getAccountNumberMasked(account = {}, accountNumber = "") {
  const masked =
    account.account_number_masked || account.accountNumberMasked || "";
  if (masked) return masked;

  const digits = String(accountNumber || "").replace(/\D/g, "");
  return digits ? `XX${digits.slice(-4)}` : "XX----";
}

/** Map player API bank account to the shape used by withdraw UI. */
export function normalizeBankAccount(account = {}) {
  const accountNumber = account.account_number || account.accountNumber || "";

  return {
    ...account,
    bankId: account.id || account.bank_id || account.bankId || "",
    bankName: account.bank_name || account.bankName || "",
    accountNumber,
    accountNumberMasked: getAccountNumberMasked(account, accountNumber),
    accountHolderName:
      account.account_holder_name || account.accountHolderName || "",
    ifscCode: account.ifsc_code || account.ifscCode || "",
    accountType: account.account_type || account.accountType || "savings",
    payoutMethod: account.payout_method || account.payoutMethod || "bank",
    isVerified: isVerifiedAccount(account),
    isPrimary: Boolean(account.is_primary ?? account.isPrimary),
  };
}

export function normalizeBankAccounts(accounts = []) {
  if (!Array.isArray(accounts)) return [];
  return accounts
    .filter((account) => !isUpiPayoutAccount(account))
    .map(normalizeBankAccount);
}
